<div class="loading" *ngIf="!isBrowser">
  <img
    src="/assets/images/gif/trustpointpharma.gif"
    alt="Loading Quick Pharma"
  />
</div>

<main id="main-content" class="page-render-root">
  <router-outlet></router-outlet>
</main>

<!----scroll-->
<div class="scroll">
  <button
    #scroll
    type="button"
    (click)="scrollTop()"
    aria-label="Scroll to top"
  >
    <i
      style="transform: rotate(180deg)"
      class="fa fa-arrow-down fa-2x"
      aria-hidden="true"
    ></i>
  </button>
</div>

<div class="down-arrow"></div>
